import { Flex } from "@fluentui/react-northstar";
import React, { useContext } from "react";
import { ReactNode } from "react";
import { RegularText } from "shared/components";
import styles from "./contactDetailsItem.module.scss";
import { constants } from "shared/constants";
import { ResizerContext } from "shared/stores/resizeStore/ResizerContext";

export interface ContactDetailsItemProps {
    label: string;
    content: ReactNode;
    readonly?: boolean;
    wrap?: boolean;
}

export const ContactDetailsItem: React.FC<ContactDetailsItemProps> = (props) => {
    const resizeContext = useContext(ResizerContext);
    const isMobile = resizeContext.windowWidth < 900; // not const value for medium device

    const shouldWrap = () => {
        return props.wrap || isMobile;
    };

    return (
        <Flex column gap="gap.small">
            <Flex
                fill
                vAlign={!props.readonly ? "center" : undefined}
                column={shouldWrap()}
                gap="gap.small">
                <RegularText
                    isLabel
                    className={styles.label}
                    content={props.label}
                />
                {props.content}
            </Flex>
        </Flex>
    )
}
